import React from 'react';
import ShowDeleteTruckWarningComponent from './ShowDeleteTruckWarningComponent';
import { Truck } from '../../models/truck';

interface Props {
  truck: Truck;
  submit: (truck: Truck) => void;
  hide: () => void;
}

// tslint:disable-next-line:variable-name
const DeleteTruckComponent = (props: Props) => <ShowDeleteTruckWarningComponent {...props } />;

export default DeleteTruckComponent;
